import React from "react";
import { ModalHeader, ModalTitle } from "@atlaskit/modal-dialog";
import { useDispatch, useSelector } from "react-redux";
import { setWizardPage, setWizard, setWizardErrorMsg, setWizardCategory, clearWizard } from "../../redux/actions/wizardActions";
import { clearAsset} from "../../redux/actions/jiraAssetsActions";
import Button from "@atlaskit/button/standard-button";
import CrossIcon from "@atlaskit/icon/core/cross";
import { N500 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";
import Left from "@atlaskit/icon/core/arrow-left";

const WizardModalHeader = () => {
  const currentPage = useSelector((state) => state.wizard.currentPage);
  const currentCategory = useSelector((state) => state.wizard.currentCategory);
  const currentWizard = useSelector((state) => state.wizard.currentWizard);

  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(clearWizard(false));
    dispatch(clearAsset(0));
  };
  const onClickPrev = () => {
    dispatch(setWizardErrorMsg(""));
    if(currentCategory !== "" && currentPage === 0){
      dispatch(setWizardCategory(""));
    }else{
      dispatch(setWizardPage(currentPage - 1));
      dispatch(setWizard(currentWizard));

    }
  };
  return (
    <ModalHeader>
      {(currentPage > 0 || currentCategory !== "") && (
        <Button appearance="link" onClick={onClickPrev}>
          <Left
            label="Prev. Step"
            color={token("color.text.subtle", N500)}
          />
        </Button>
      )}
      <ModalTitle>Integration Wizard</ModalTitle>
      <Button appearance="link" onClick={closeModal}>
        <CrossIcon
          label="Close Modal"
          color={token("color.text.subtle", N500)}
        />
      </Button>
    </ModalHeader>
  );
};
export default WizardModalHeader;
